<!DOCTYPE html>
<html lang="en">
  <head>
    <meta charset="utf-8" />
    <title>OpenX</title>
    <base href="/" />

    <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no" />
    <link rel="icon" type="image/x-icon" href="assets/favicon.ico" sizes="32x32"/>
    <link rel="icon" type="image/svg+xml" href="assets/favicon.svg" />
    <link rel="apple-touch-icon" href="assets/apple-touch-icon.png" />

    <link rel="preconnect" href="https://fonts.googleapis.com">
    <link rel="preconnect" href="https://gstatic.com" crossorigin>
    <link href="https://fonts.googleapis.com/css?family=Figtree:300,400,500,600,700&display=swap" rel="stylesheet" />
    <link rel="stylesheet" href="https://fonts.googleapis.com/icon?family=Material+Icons&display=swap" />
    <script>
      // fix needed for GraphiQLPage.tsx
      if (global === undefined) {
        var global = window;
      }
    </script>
    <script src="config.js?v=2"></script>
  </head>
  <body>
    <div id="root"></div>
  <script type='module' src='/src/main.tsx'></script>
          </body>
</html>
